import ContactValuePanel from './ContactValuePanel';

export default ContactValuePanel;
